// extracted by mini-css-extract-plugin
export default {"CropperModal":"CropperModal_CropperModal__0BqDJ"};